export default "__VITE_ASSET__BUs4TwMk__"